var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "transferDate",
                    expression: "'transferDate'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("transferDate"),
                  name: "transferDate",
                  label: "划账日期",
                  placeholder: "划账日期",
                  "input-align": "right",
                  disabled: _vm.isDisabled("transferDate"),
                  rules: _vm.getRules("transferDate"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.transferDate,
                            placeholder: "请选择划账日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.transferDate,
                                "transferDate"
                              )
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "transferDate",
                          attrs: {
                            "min-date": _vm.transferDate.minDate,
                            "max-date": _vm.transferDate.maxDate,
                            "show-confirm": false,
                            title: "选择划账日期",
                          },
                          on: { confirm: _vm.transferDateConfirm },
                          model: {
                            value: _vm.transferDate.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.transferDate, "show", $$v)
                            },
                            expression: "transferDate.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.transferDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "transferDate", $$v)
                  },
                  expression: "formData.transferDate",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sy",
                    expression: "'sy'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("sy"),
                  required: _vm.isRequired("sy"),
                  rules: _vm.getRules("sy"),
                  name: "sy",
                  type: "textarea",
                  maxlength: "100",
                  rows: "3",
                  autosize: "",
                  label: "划转事由",
                  "show-word-limit": "",
                  placeholder: "请输入划转事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sy", $$v)
                  },
                  expression: "formData.sy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "transferType",
                    expression: "'transferType'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("transferType"),
                  required: _vm.isRequired("transferType"),
                  name: "transferType",
                  label: "划转分类",
                  placeholder: "划转分类",
                  "input-align": "right",
                  rules: _vm.getRules("transferType"),
                  readonly: "",
                  clickable: "",
                },
                on: {
                  click: function ($event) {
                    _vm.showPicker = true
                  },
                },
                model: {
                  value: _vm.formData.transferType,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "transferType", $$v)
                  },
                  expression: "formData.transferType",
                },
              }),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom" },
                  model: {
                    value: _vm.showPicker,
                    callback: function ($$v) {
                      _vm.showPicker = $$v
                    },
                    expression: "showPicker",
                  },
                },
                [
                  _c("van-picker", {
                    attrs: { "show-toolbar": "", columns: _vm.columns },
                    on: {
                      confirm: _vm.onConfirm,
                      cancel: function ($event) {
                        _vm.showPicker = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.formData.transferType === "产值"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "contract",
                        expression: "'contract'",
                      },
                    ],
                    attrs: {
                      required: _vm.isRequired("contract"),
                      rules: _vm.getRules("contract"),
                      name: "contract",
                      label: "合同",
                      placeholder: "请输入合同",
                      "input-align": "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("view-item", {
                                attrs: {
                                  value: _vm.getContractName(),
                                  placeholder: "请选择合同",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.isShowPopup(
                                      _vm.contract,
                                      "contract"
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3148155733
                    ),
                    model: {
                      value: _vm.formData.contract,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "contract", $$v)
                      },
                      expression: "formData.contract",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "transferAmount",
                    expression: "'transferAmount'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("transferAmount"),
                  disabled: _vm.isDisabled("transferAmount"),
                  name: "transferAmount",
                  label: "划转金额",
                  placeholder: "划转金额",
                  "input-align": "right",
                  maxlength: 10,
                  rules: _vm.getRules("transferAmount"),
                  type: "number",
                },
                on: {
                  blur: function ($event) {
                    return _vm.formatTransferAmount(
                      $event,
                      _vm.formData,
                      "transferAmount"
                    )
                  },
                },
                model: {
                  value: _vm.formData.transferAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "transferAmount", $$v)
                  },
                  expression: "formData.transferAmount",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "transferFrom",
                    expression: "'transferFrom'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "transferFrom",
                  required: _vm.isRequired("transferFrom"),
                  value: _vm.formData.transferFrom,
                  rules: _vm.getRules("transferFrom"),
                  label: "转出方",
                  placeholder: "请选择转出方",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.getTransferName("transferFrom"),
                            placeholder: "请选择转出方",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.transferFrom,
                                "transferFrom"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.transferFrom.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.transferFrom, "show", $$v)
                              },
                              expression: "transferFrom.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择转出方",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.transferFrom.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.businessSelectFinish(
                                    "transferFrom"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.transferFrom,
                                            "name",
                                            "columnsLabel"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.transferFrom.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.transferFrom,
                                            "filterText",
                                            $$v
                                          )
                                        },
                                        expression: "transferFrom.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "transferFrom",
                              attrs: {
                                duration: 0,
                                "value-key": "columnsLabel",
                                columns: _vm.transferFrom.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.transferFrom.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "transferTo",
                    expression: "'transferTo'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "transferTo",
                  required: _vm.isRequired("transferTo"),
                  value: _vm.formData.transferTo,
                  rules: _vm.getRules("transferTo"),
                  label: "转入方",
                  placeholder: "请选择转入方",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.getTransferName("transferTo"),
                            placeholder: "请选择转入方",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.transferTo,
                                "transferTo"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.transferTo.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.transferTo, "show", $$v)
                              },
                              expression: "transferTo.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择转入方",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.transferTo.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.businessSelectFinish("transferTo")
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.transferTo,
                                            "name",
                                            "columnsLabel"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.transferTo.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.transferTo,
                                            "filterText",
                                            $$v
                                          )
                                        },
                                        expression: "transferTo.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "transferTo",
                              attrs: {
                                duration: 0,
                                "value-key": "columnsLabel",
                                columns: _vm.transferTo.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.transferTo.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "filesComponentBox fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      _c("van-notice-bar", {
        attrs: {
          scrollable: "",
          text: "流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。",
        },
      }),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            attrs: {
              actCurrentNode: _vm.processData.actCurrentNode || "",
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-35", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("relativeFlow", {
        attrs: { show: _vm.relativeFlow.show },
        on: {
          finish: _vm.relativeFlowFinish,
          close: function ($event) {
            _vm.relativeFlow.show = false
          },
        },
      }),
      _c("contract", {
        attrs: { show: _vm.contract.show },
        on: {
          finish: _vm.contractFinish,
          close: function ($event) {
            _vm.contract.show = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }